export default [
  {
    path: "/objective-type",
    name: "ObjectiveType",
    component: () => import("@/views/Page/StrategicPlan/ObjectiveType/ObjectiveType.vue"),
    meta: {
      title: "ObjectiveType",
    },
  },
];
